import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import {
  InputLabel,
  Input,
  Button,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import { listOneTaxrate, updateTaxrate } from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import ConfirmDialog from "../components/ConfirmDialog";
import Notification from "../components/Notification";
import { TAXRATE_UPDATE_RESET } from "../constants/financeConstants";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";
import AddRemoveCat from "components/AddRemoveCat";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

const useStyles = makeStyles(styles);

export default function TaxrateDetailScreen(props) {
  const classes = useStyles();
  const { id } = useParams();
  const recordId = id;
  console.log("recordId:" + recordId);

  const recordDetails = useSelector((state) => state.taxrateDetails);
  const { loading, error, taxrate: record } = recordDetails; //use previous records
  const [selectcatShow, setSelectcatShow] = useState(
    "Original Included categories"
  );
  const [updateBtnShow, setUpdateBtnShow] = useState(true);
  const [taxrate, setTaxrate] = useState(0.13);
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState([]);
  const [otherinfo, setOtherinfo] = useState("");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const navigate = useNavigate();
  // const { requrl }= useParams();

  //const confirmedCategory = (addedCategories, addedCatIDs) => {
  const confirmedCategory = (addedCategories, onConfirmed) => {
    if (onConfirmed) {
      setSelectcatShow("Re-Selected Categories");
      setUpdateBtnShow(false);
      //setOriginalcatDisabled("display:none");
    } else {
      //setSelectcatDisabled("display:none");
      setSelectcatShow("Original Included categories");
      setUpdateBtnShow(true);
    }
    setCategory(addedCategories);

    //setAddedCatIDs(addedCatIDs);
  };
  console.log("confirmedCategory: " + category);

  const recordUpdate = useSelector((state) => state.taxrateUpdate);

  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = recordUpdate;

  const dispatch = useDispatch();
  const dispatch2 = useDispatch();

  useEffect(() => {
    if (successUpdate) {
      //props.history.push('/recordlist');
      navigate("/edittax", { replace: true });
    }
    if (!record || record._id !== recordId || successUpdate) {
      dispatch({ type: TAXRATE_UPDATE_RESET });
      dispatch2(listOneTaxrate(recordId));
    } else {
      setDescription(record.description);
      setCategory(record.category);
      setOtherinfo(record.otherinfo);
      setTaxrate(record.taxrate);
    }
  }, [dispatch, dispatch2, record, successUpdate, props.history]);

  console.log("record:" + record);

  const submitHandler = (e) => {
    // e.preventDefault();
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    dispatch(
      updateTaxrate({
        _id: recordId,
        description,
        category,
        otherinfo,
        taxrate,
      })
    );
    setNotify({
      isOpen: true,
      message: "Records Updated Successfully",
      type: "success",
    });
  };
  const updateTaxrateCategory = () => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    dispatch(
      updateTaxrate({
        _id: recordId,
        description,
        category,
        otherinfo,
        taxrate,
      })
    );
    setNotify({
      isOpen: true,
      message: "Taxrate Records Updated Successfully",
      type: "success",
    });
  };
  //const userSignin = useSelector((state) => state.userSignin);
  //const { userInfo } = userSignin;
  const getFilterUrl = (id) => {
    return `/edittaxcategory/${id}`;
  };

  return (
    <div>
      <div className={classes.space30}> </div>
      <GridItem xs={12} sm={12} md={4}>
        <Button
          variant="outlined"
          className="medium"
          startIcon={
            <KeyboardBackspaceOutlinedIcon sx={{ color: "#E91E63" }} />
          }
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </GridItem>
      <div>
        <h3>Update Taxrate Detail</h3>
      </div>
      {loadingUpdate && <LoadingBox></LoadingBox>}
      {errorUpdate && <MessageBox variant="danger">{errorUpdate}</MessageBox>}
      {loading ? (
        <LoadingBox></LoadingBox>
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <div>
          <GridContainer justify="center" className={classes.contentText}>
            <GridItem xs={12} sm={12} md={6} className={classes.topSpace}>
              {/* 
              <form className="form" onSubmit={submitHandler}>
              */}

              <div>
                <InputLabel
                  htmlFor="description"
                  className={classNames(classes.upperCase, classes.subTitle)}
                >
                  Description
                </InputLabel>
                <Input
                  type="text"
                  id="description"
                  fullWidth="true"
                  placeholder="Enter description"
                  defaultValue={record.description}
                  onChange={(e) => setDescription(e.target.value)}
                ></Input>
              </div>
              <div className={classes.space30}> </div>

              <div>
                <InputLabel
                  htmlFor="taxrate"
                  className={classNames(classes.upperCase, classes.subTitle)}
                >
                  Taxrate
                </InputLabel>
                <Input
                  type="number"
                  id="taxrate"
                  placeholder="Enter Taxrate"
                  defaultValue={Number(record.taxrate).toFixed(2)}
                  onChange={(e) => setTaxrate(e.target.value)}
                ></Input>
              </div>
              <div className={classes.space30}> </div>
              <div>
                <InputLabel
                  htmlFor="otherinfo"
                  className={classNames(classes.upperCase, classes.subTitle)}
                >
                  Other information
                </InputLabel>
                <Input
                  type="otherinfo"
                  id="otherinfo"
                  placeholder="please add more information if needs"
                  fullWidth="true"
                  defaultValue={record.otherinfo}
                  onChange={(e) => setOtherinfo(e.target.value)}
                ></Input>
              </div>

              {/* 
                                  <InputLabel></InputLabel>

                  <Button type="submit" variant="outlined" size="small">
                    Update Taxrate
                  </Button>

              </form>
                
                */}
            </GridItem>

            <GridItem xs={12} sm={12} md={6} className={classes.topSpace}>
              <div className={classes.space30}> </div>
              <InputLabel
                htmlFor="Category"
                className={classNames(classes.upperCase, classes.subTitle)}
              >
                {selectcatShow}
              </InputLabel>

              <TextareaAutosize
                maxRows={4}
                id="category"
                aria-label="maximum height"
                placeholder="Selected Category"
                defaultValue={category}
                style={{ width: "100%", border: "none" }}
              />

              <div className={classes.space30}> </div>
              <InputLabel
                htmlFor="UpdatedCategory"
                className={classNames(classes.upperCase, classes.subTitle)}
              >
                To Update Taxrate Category, <br />
                Please Re-Select Categories
              </InputLabel>
              <AddRemoveCat
                originalCategories={category}
                confirmedCategory={confirmedCategory}
              />
              <div className={classes.space30}> </div>
              <Button
                disabled={updateBtnShow}
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "Are you sure to Update the Taxrate record?",
                    subTitle:
                      "You can't UNDO this operation once you click YES!",
                    onConfirm: () => {
                      updateTaxrateCategory();
                    },
                  });
                }}
                variant="outlined"
                size="small"
              >
                Update Taxrate Category
              </Button>
            </GridItem>
            <Notification notify={notify} setNotify={setNotify}></Notification>
            <ConfirmDialog
              confirmDialog={confirmDialog}
              setConfirmDialog={setConfirmDialog}
            />
          </GridContainer>
        </div>
      )}
    </div>
  );
}
